// Hooks
import { createFormContext, useForm } from 'hooks';

export const EFOContext = createFormContext();

export const useEFO = useForm;
export default useEFO;
